import { type InfiniteData, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { type Board, type ListResponse } from '@air/api/types';

import { getPrivateBoardsListKey } from '~/components/v2/hooks/queries/usePrivateBoardsList';
import { useFavoriteBoardsParams } from '~/components/v2/hooks/useFavoriteBoardsParams';
import { getRearrangedBoards, mergeReorderedSiblingsIntoFlatList } from '~/utils/mutateUtils/mutators';

export const useFavoriteBoardsCacheUpdate = () => {
  const queryClient = useQueryClient();
  const { getFavoriteBoardsParams } = useFavoriteBoardsParams();

  const updateFavoriteBoardsCache = useCallback(
    ({
      rearrangedBoards,
      insertAtIndex,
      reorderedSiblings,
    }: {
      rearrangedBoards?: Board[];
      insertAtIndex?: number;
      reorderedSiblings?: Board[];
    }) => {
      const updater = reorderedSiblings
        ? mergeReorderedSiblingsIntoFlatList(reorderedSiblings)
        : getRearrangedBoards(rearrangedBoards ?? [], insertAtIndex);

      queryClient.setQueriesData<InfiniteData<ListResponse<Board>> | undefined>(
        {
          queryKey: getPrivateBoardsListKey(getFavoriteBoardsParams()),
        },
        updater,
      );
    },
    [getFavoriteBoardsParams, queryClient],
  );

  return {
    updateFavoriteBoardsCache,
  };
};
